import React, { createContext, useState } from "react";

import PropTypes from "prop-types";

export const BankAccountContext = createContext();

export const BankAccountProvider = ({children}) => {
	const [ bankAccountSelected, setBankAccountSelected ] = useState(null); // Will Handle a Object/Dictionary
	const [editedTransactions, setEditedTransactions] = useState({});

	const updateBasePointsFromBankAccountSelected = (
		updatedBasePoints, updatedTemporalBasePoints, updateDataFunction
	) => {
		const { balanceToUpdate } = calculateUpdatedBalance({
			initialAmount: bankAccountSelected.initial_amount,
			basePoints: updatedBasePoints,
			temporalBasePoints: updatedTemporalBasePoints,
			bankAccount: bankAccountSelected,
		});

		const bankAccountUpdated = {
			...bankAccountSelected,
			basePoints: updatedBasePoints,
			temporalBasePoints: updatedTemporalBasePoints,
			balance: balanceToUpdate,
			initial_amount: bankAccountSelected.initial_amount,
		};
	
		setBankAccountSelected(bankAccountUpdated);
		if(updateDataFunction) updateDataFunction(bankAccountUpdated);
	};
	
	const calculateUpdatedBalance = ({
		initialAmount = 0,
		basePoints = {},
		temporalBasePoints = {},
		bankAccount = {},
	}) => {
		let balanceToUpdate = bankAccount?.balance ?? 0;
	
		if (Object.keys(temporalBasePoints).length !== 0) {
			const lastKey = Object.keys(temporalBasePoints).sort((a, b) => new Date(a) - new Date(b)).pop();
			const lastValue = temporalBasePoints[lastKey] ?? 0;
			balanceToUpdate = lastValue;
		} else if (Object.keys(basePoints).length !== 0) {
			const lastKey = Object.keys(basePoints).sort((a, b) => new Date(a) - new Date(b)).pop();
			const lastValue = basePoints[lastKey] ?? 0;
			balanceToUpdate = lastValue;
		} else if (Object.keys(basePoints).length === 0 && Object.keys(bankAccount?.basePoints || {}).length !== 0) {
			const lastKey = Object.keys(bankAccount?.basePoints).sort((a, b) => new Date(a) - new Date(b)).pop();
			const lastValue = bankAccount?.basePoints[lastKey] ?? 0;
			balanceToUpdate = lastValue;
		} else {
			balanceToUpdate = initialAmount;
		}
	
		return {
			balanceToUpdate,
			basePoints,
			temporalBasePoints,
		};
	};
			
	return (
		<BankAccountContext.Provider value={{
			bankAccountSelected, 
			editedTransactions, 
			setBankAccountSelected,
			updateBasePointsFromBankAccountSelected,
			calculateUpdatedBalance,
			setEditedTransactions,
		}}>
			{children}
		</BankAccountContext.Provider>
	);
};

BankAccountProvider.propTypes = {
	children: PropTypes.node.isRequired,
};